// extracted by mini-css-extract-plugin
export default {"container":"Slider_container__rhjyz","photo":"Slider_photo__Jsryq"};